import React from 'react'

import { shape, string } from 'prop-types'

import BrowseAllButton from 'Pods/Shared/BrowseAllButton'
import ModelIcon from 'Pods/Shared/ModelIcon/ModelIcon'

function CategoryHeader({ category, BrowseAllText }) {
  return (
    <div className="categories-section__category-header">
      <div className="categories-section__category-header-content">
        <div className="categories-section__category-title-section">
          <ModelIcon icon={category.slug} width="24" height="24" />
          <h2 className="categories-section__category-title">
            <a href={category.path} className="categories-section__category-link">
              {category.title}
            </a>
          </h2>
        </div>
        <div className="categories-section__category-description">{category.description}</div>
      </div>
      <BrowseAllButton
        href={category.path}
        text={BrowseAllText}
        className="categories-section__browse-all-desktop"
      />
    </div>
  )
}

CategoryHeader.propTypes = {
  category: shape({
    slug: string.isRequired,
    title: string.isRequired,
    description: string.isRequired,
  }).isRequired,
  BrowseAllText: string.isRequired,
}

export default CategoryHeader
